import { render } from "./02_DashobardSectionSIM.vue?vue&type=template&id=cc6277fe"
import script from "./02_DashobardSectionSIM.vue?vue&type=script&lang=js"
export * from "./02_DashobardSectionSIM.vue?vue&type=script&lang=js"

import "./02_DashobardSectionSIM.vue?vue&type=style&index=0&id=cc6277fe&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__